import React from 'react';
import Header from './components/layout/Header';
import Toolbar from './components/layout/Toolbar';
import Canvas from './components/canvas/Canvas';
import PropertiesPanel from './components/panels/PropertiesPanel';
import useEditorStore from './store/editorStore';
import './App.css';

function App() {
  const { 
    initializeDefaultSections, 
    sections, 
    deleteBlock, 
    selectedBlockId 
  } = useEditorStore();
  
  // Initialize default sections on mount
  React.useEffect(() => {
    if (sections.length === 0) {
      initializeDefaultSections();
    }
  }, []);

  // Handle keyboard shortcuts
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore if user is typing in an input or textarea
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName) || 
          document.activeElement.isContentEditable) {
        return;
      }

      // Delete block
      if ((e.key === 'Delete' || e.key === 'Backspace') && selectedBlockId) {
        e.preventDefault();
        deleteBlock(selectedBlockId);
      }

      // Undo/Redo (Placeholder for future implementation)
      if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
        e.preventDefault();
        // undo();
        console.log('Undo not implemented yet');
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.shiftKey && e.key === 'z'))) {
        e.preventDefault();
        // redo();
        console.log('Redo not implemented yet');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedBlockId, deleteBlock]);
  
  return (
    <div className="app">
      <Header />
      <div className="app-body">
        <Toolbar />
        <div className="canvas-container">
          <Canvas />
        </div>
        <PropertiesPanel />
      </div>
    </div>
  );
}

export default App;
